import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { SetCompactView } from "./compact-view.actions";

export interface CompactViewStateModel {
	isCompact: boolean;
}

@State<CompactViewStateModel>({
	name: 'CompactViewStateModel',
	defaults: {
		isCompact: false
	},
})
@Injectable()
export class CompactViewState {
	@Selector()
	static isComapct({ isCompact: compact }: CompactViewStateModel): boolean {
		return compact;
	}

	@Action(SetCompactView)
	setCompactView(
		{ patchState }: StateContext<CompactViewStateModel>,
		{ setCompactView }: SetCompactView
	): void {
		patchState({
			isCompact: setCompactView,
		});
	}
}
